import report from '../../../apis/report';

const fetchCancelledPaymentsLog = async (
  academicYear: string,
  grade: string
) => {
  const usersDayWiseFeeBookReport: any[] = [];
  const perPage = 200;
  let pageNo = 1;
  let hasMoreData = true;

  do {
    const response: any = await report.fetchCancelledPaymentsLog(
      academicYear === 'All' ? '' : academicYear,
      grade === 'All' ? '' : grade,
      pageNo,
      perPage
    );

    if (response?.data) {
      usersDayWiseFeeBookReport.push(...response.data);
    }

    hasMoreData = response?.hasMore || false;
    pageNo += 1;
  } while (hasMoreData);

  return usersDayWiseFeeBookReport;
};

export default fetchCancelledPaymentsLog;
